import { cn, getInitialsFromDisplayName } from "@/utils/utils";
import { EmployeeProfileStatus, User } from "@common/utils/graphql/generated";
import { Body } from "@hypercard/web-components";
import { ColumnDef } from "@tanstack/react-table";
import { getRoleOrEmployeeStatus } from "./utils";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export const peopleTabColumns: ColumnDef<User>[] = [
  {
    accessorKey: "displayName",
    header: "NAME",
    cell: ({ row }) => (
      <div
        className={cn("flex items-center space-x-4", {
          "opacity-30":
            row.original.employee?.status === EmployeeProfileStatus.Terminated,
        })}
      >
        {/* Avatar */}
        <Avatar>
          <AvatarFallback>
            {getInitialsFromDisplayName(row.original.displayName)}
          </AvatarFallback>
        </Avatar>
        {/* Display name and email */}
        <div className="space-y-0.5">
          <Body size="md" weight="medium">
            {row.original.displayName}
          </Body>
          {/* Employee email */}
          {/* TODO: what happens here when terminated? */}
          {row.original.employee?.workEmail && (
            <Body size="sm" weight="regular" className="opacity-70">
              {row.original.employee.workEmail}
            </Body>
          )}
        </div>
      </div>
    ),
  },
  {
    accessorKey: "employee.department.name",
    header: "DEPARTMENT",
    cell: ({ row }) => (
      <Body
        size="md"
        weight="regular"
        className={cn({
          "opacity-30":
            row.original.employee?.status === EmployeeProfileStatus.Terminated,
        })}
      >
        {row.original.employee?.department.name}
      </Body>
    ),
  },
  {
    accessorKey: "employeeDisplayRole",
    header: "ROLE",
    cell: ({ row }) => (
      <Body
        size="md"
        weight="regular"
        className={cn({
          "opacity-30":
            row.original.employee?.status === EmployeeProfileStatus.Terminated,
        })}
      >
        {getRoleOrEmployeeStatus(row.original)}
      </Body>
    ),
  },
  {
    accessorKey: "employee.manager.displayName",
    header: "MANAGER",
    cell: ({ row }) => (
      <Body
        size="md"
        weight="regular"
        className={cn({
          "opacity-30":
            row.original.employee?.status === EmployeeProfileStatus.Terminated,
        })}
      >
        {row.original.employee?.manager?.displayName || "No manager"}
      </Body>
    ),
  },
];
